import { assertUserFlagsAreUnique, type UserSettings } from "@/services/user/settings";
import { UserFlag } from "@/services/user/settings/flags";
import { ref, watch } from "vue";

const userSettings = ref<UserSettings>();

export function useUserSettings() {
  const userHasFlag = (flag: UserFlag): boolean => {
    return userSettings.value?.flags.includes(flag) ?? false;
  };

  const removeUserFlag = (flag: UserFlag): void => {
    userSettings.value?.flags.splice(userSettings.value?.flags.indexOf(flag), 1);
  };

  // Extra validator to be sure
  watch(userSettings, (newSetting) => {
    if (newSetting !== undefined) {
      assertUserFlagsAreUnique(newSetting.flags);
    }
  });

  return {
    userSettings,

    userHasFlag,
    removeUserFlag,
  };
}
